export default __webpack_public_path__ + "static/media/pic1.b8e31612.jpg";